import React, { useMemo } from 'react';
import { BackgroundThemeRevision, ColorId } from 'referral-types';
import { rgbStringToHex } from '../../../../../utils/colorUtils';
import { useTheme } from '../../../../../context/theme/useTheme';
import { useBodyStyleVersion } from '../../../../../hooks/useBodyStyleVersion';
import { getCssVariableForColorId } from '../../../../../constants';

const CrosshatchCubesBackground: React.FC<{ themeRevision?: Partial<BackgroundThemeRevision> }> = (props) => {
  const { colorId1, colorId2 } = props.themeRevision || {};
  const { isDarkMode } = useTheme();
  const bodyStyleVersion = useBodyStyleVersion();

  const computedColors = useMemo(() => {
    const colorStyles1 = getCssVariableForColorId(colorId1 || ColorId.Tertiary2, isDarkMode);
    const colorStyles2 = getCssVariableForColorId(colorId2 || ColorId.Tertiary4, isDarkMode);

    const rootStyles = getComputedStyle(document.body);
    const c1 = rgbStringToHex(rootStyles.getPropertyValue(colorStyles1).trim() || '255 204 0');
    const c2 = rgbStringToHex(rootStyles.getPropertyValue(colorStyles2).trim() || '204 153 0');

    return {
      c1,
      c2,
    };
  }, [colorId1, colorId2, isDarkMode, bodyStyleVersion]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        backgroundColor: computedColors.c1,
        pointerEvents: 'none',
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 2000 1200"
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <g id="crosshatch-a" fill={computedColors.c2}>
            <path d="M0 0 234 140.1 0 10z" />
            <path d="M0 10 234 150.1 0 20z" />
            <path d="M0 20 234 160.1 0 30z" />
          </g>
          <g id="crosshatch-b">
            <use xlinkHref="#crosshatch-a" y="0" />
            <use xlinkHref="#crosshatch-a" y="30" />
            <use xlinkHref="#crosshatch-a" y="60" />
          </g>
          <g id="crosshatch-c">
            <path fill={computedColors.c1} d="M234 135.1 0 0 0 270.2 234 405.3z" />
            <use xlinkHref="#crosshatch-b" y="0" />
            <use xlinkHref="#crosshatch-b" y="90" />
            <use xlinkHref="#crosshatch-b" y="180" />
          </g>
          <g id="crosshatch-d">
            <use xlinkHref="#crosshatch-c" x="0" y="0" />
            <use xlinkHref="#crosshatch-c" x="-233.8" y="-405.1" transform="rotate(120)" />
            <use xlinkHref="#crosshatch-c" x="-467.8" y="0" transform="rotate(-120)" />
          </g>
          <pattern id="crosshatch-p" width="936" height="810.6" patternUnits="userSpaceOnUse">
            <use xlinkHref="#crosshatch-d" x="0" y="0" />
            <use xlinkHref="#crosshatch-d" x="468" y="0" />
            <use xlinkHref="#crosshatch-d" x="234" y="405.3" />
            <use xlinkHref="#crosshatch-d" x="-234" y="405.3" />
            <use xlinkHref="#crosshatch-d" x="702" y="405.3" />
            <use xlinkHref="#crosshatch-d" x="0" y="810.6" />
            <use xlinkHref="#crosshatch-d" x="468" y="810.6" />
          </pattern>
        </defs>
        <rect fill="url(#crosshatch-p)" width="100%" height="100%" />
      </svg>
    </div>
  );
};

export default CrosshatchCubesBackground;
